import product1 from "./Pages/Assets/1.png";
import product2 from "./Pages/Assets/2.png";
import product3 from "./Pages/Assets/3.png";
import product4 from "./Pages/Assets/4.png";
import product5 from "./Pages/Assets/5.png";
import product6 from "./Pages/Assets/6.webp";
import product7 from "./Pages/Assets/7.webp";
import product8 from "./Pages/Assets/8.webp";
import product9 from "./Pages/Assets/9.jpeg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "blue sweater",
    desc: " Men's round neck sweater color blue 90% coton",
    price: 449,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Blouson bombardier homme",
    desc: " Men's bomber jacket color brown",
    price: 549,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Blouson a manches contrastantes",
    desc: "",
    price: 899,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Jean homme coupe Regular",
    desc: "",
    price: 699,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Manteau homme court",
    desc: "",
    price: 819,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Pyjama homme",
    desc: "",
    price: 979,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Pull homme à col roulé",    
    desc: "",
    price: 449,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Pull de Noël homme",
    desc: "",
    price: 399,
    productImage: product8,
  },
  {
    id: 9,
    productName: "ensemble polo tee-shirt et pantalon de la toile",
    desc: "",
    price: 1399,
    productImage: product9,
  },
];
